import GenerateSingularOrPlural from './generateSingularOrPlural.utility';

class DaySingularOrPlural extends GenerateSingularOrPlural {
  singularWord = 'day';

  pluralWord = 'days';
}
export default DaySingularOrPlural;
